const fragment = `
  id
  isPrimary
  inviteEmail
  inviteSentAt
  inviteAcceptedAt
  contact {
    id
    name
    firstName
    lastName
    email
    isEmailVerified(companyId: $companyId)
    isIdVerified
    isFinancialVerified
    lastActivityDate(companyId: $companyId)
    companyContact(companyId: $companyId) {
      verifiedIdGranted
      verifiedFinancialGranted
      affordability {
        maxHomeAffordability
        assessedAt
        monthlyMortgagePayment
        maxRentingAmount
        annualIncome
      } 
      createdAt
    }
    user {
      idVerification {
        id
        status
        customerInfo {
          firstName
          lastName
          identificationDocument {
            documentType
            documentNumbers
          }
        }
      }
      preApproval {
        id
        amount
        verificationMethod
        status
      }
    }
    financialSummary {
      employerPrimaryName
    }
  }
`;

export const listPartyContactsQuery = `
  query ListPartyContacts(
    $filter: PartyContactFilterInput
    $companyId: Int
  ) {
    items: listPartyContacts(filter: $filter) {
      ${fragment}
    }
  }
`;
